import { IModel } from "makerjs";
import { AbstractValidator, ValidatorObject } from "./AbstractValidator";

import { ValidatorInterface } from "./ValidatorInterface";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";
import { sprintf } from 'sprintf-js';

export class CustomDrillHoleMissingValidator extends AbstractValidator implements ValidatorInterface {

	constructor(
		private baseModel: IModel,
		private combinedModel: IModel,
		private drillHoleId: string,
		options: ValidatorObject
	) {
		super(options);
	}

	getMessage(): string {
		const { drillHole: drillHoleMessages } = window.measurementSelectorVariables.i18n.validators;
		return sprintf( drillHoleMessages.custom.incorrect, 1 ) ?? 'Drillhole is incorrect. Please check the offsets';
	}

	isValid(): boolean {
		let isValid = true;

		const options = {
			contain: true,
		};

		const cutoutModel = this.combinedModel.models.cutoutModel;

		const baseModelChains = makerjs.model.findChains(this.baseModel, options);
		makerjs.model.simplify(this.combinedModel); // Removes duplicate link paths
		const combinedShapeChains = makerjs.model.findChains(this.combinedModel, options);

		if (!Array.isArray(baseModelChains) || !Array.isArray(combinedShapeChains)) {
			return false;
		}

		// Check if the drill hole exists in the base model, if not, the drill hole is missing
		if(!this.checkPathIdExists(cutoutModel.models.baseModel.models, this.drillHoleId) ) {
			isValid = false;
		}

		// Check if the combined shape has a longer path than the base model
		// If it does, it means that the drill hole is on the edge of the base model
		combinedShapeChains.forEach((chain: makerjs.IChain, index) => {
			if(chain.pathLength > baseModelChains[index].pathLength) {
				isValid = true;
			}
		});

		return isValid;
	}

	checkPathIdExists(models, pathId: string): boolean {
		for (const modelKey in models) {
			if (Object.prototype.hasOwnProperty.call(models, modelKey)) {
				const paths = models[modelKey].paths;
				if (Object.prototype.hasOwnProperty.call(paths, pathId)) {
					return true;
				}
			}
		}
		return false;
	}
}
